import { BenFn } from '@/common/BenFn'
import { BenQuery } from './BenQuery'

export class BenAnimate {
  static init(dones: any[]) {
    const $dom = BenQuery.query('[c-animate]')
    $dom.forEach(($item) => {
      if (dones.includes($item)) return
      _init($item)
    })
  }
}

function _init($dom: HTMLElement) {
  const runningMap = new Map()
  const delay = Number($dom.getAttribute('delay')) || 0
  const once = $dom.hasAttribute('once')
  let type = $dom.getAttribute('c-animate')
  const isMobile = BenFn.isMobileByWidth(500)
  if (isMobile && (type === 'left' || type === 'right')) type = 'up'
  const className = `c-animate-${type}`
  const observer = new IntersectionObserver(
    async (entries) => {
      for (const el of entries) {
        if (el.isIntersecting) {
          await BenQuery.sleep(delay)
          el.target.classList.add(className)
          runningMap.set(el, true)
          setTimeout(() => {
            runningMap.delete(el)
          }, 3000)
          // 开启once则观察一次后销毁监听
          if (once) observer.unobserve(el.target)
        } else {
          if (runningMap.get(el)) return
          await BenQuery.sleep(delay)
          el.target.classList.remove(className)
        }
      }
    },
    {
      threshold: 0,
      rootMargin: '200px 0px'
    },
  )
  observer.observe($dom)
}
